import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CompanySelector } from '../domain/CompanySelector';
import { LayoutDashboardIcon, UsersIcon, FileTextIcon, RepeatIcon, SettingsIcon, AlertCircleIcon } from 'lucide-react';
interface LayoutProps {
  children: ReactNode;
}
const navItems = [{
  path: '/',
  label: 'Dashboard',
  icon: LayoutDashboardIcon
}, {
  path: '/customers',
  label: 'Customers',
  icon: UsersIcon
}, {
  path: '/invoices',
  label: 'Invoices',
  icon: FileTextIcon
}, {
  path: '/subscriptions',
  label: 'Subscriptions',
  icon: RepeatIcon
}, {
  path: '/settings',
  label: 'Settings',
  icon: SettingsIcon
}];
export function Layout({
  children
}: LayoutProps) {
  const location = useLocation();
  return <div className="min-h-screen bg-gray-50" data-id="element-184">
      {/* Test Mode Banner */}
      <div className="bg-yellow-400 text-yellow-900 text-center py-1.5 text-sm font-medium flex items-center justify-center gap-2" data-id="element-185">
        <AlertCircleIcon className="w-4 h-4" data-id="element-186" />
        Test Mode - No real charges will be made
      </div>

      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40" data-id="element-187">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188">
          <div className="flex items-center justify-between h-16" data-id="element-189">
            <div className="flex items-center gap-8" data-id="element-190">
              <Link to="/" className="flex items-center gap-2" data-id="element-191">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-192">
                  <FileTextIcon className="w-5 h-5 text-white" data-id="element-193" />
                </div>
                <span className="text-xl font-bold text-gray-900" data-id="element-194">
                  BillFlow
                </span>
              </Link>

              {/* Desktop Navigation */}
              <nav className="hidden md:flex items-center gap-1" data-id="element-195">
                {navItems.map(item => {
                const isActive = location.pathname === item.path;
                const Icon = item.icon;
                return <Link key={item.path} to={item.path} className={`
                        flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium
                        transition-colors duration-150
                        ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}
                      `} data-id="element-196">
                      <Icon className="w-4 h-4" data-id="element-197" />
                      {item.label}
                    </Link>;
              })}
              </nav>
            </div>

            <div className="flex items-center gap-4" data-id="element-198">
              <CompanySelector data-id="element-199" />
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <nav className="md:hidden border-t border-gray-200 px-4 py-2 overflow-x-auto" data-id="element-200">
          <div className="flex items-center gap-1" data-id="element-201">
            {navItems.map(item => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            return <Link key={item.path} to={item.path} className={`
                    flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap
                    transition-colors duration-150
                    ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}
                  `} data-id="element-202">
                  <Icon className="w-4 h-4" data-id="element-203" />
                  {item.label}
                </Link>;
          })}
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-204">
        {children}
      </main>
    </div>;
}